<template>
  <div class="filter-form">
    <a-form
      :form="form"
      @submit="handleSubmit"
    >
      <div class="dev-form">
        <a-form-item>
          <a-checkbox-group
            v-decorator="['roleid', {initialValue: []}]"
            class="filter-role-group"
            :options="filterDatas"
          />
        </a-form-item>
      </div>
      <a-form-item class="pop-btn-box table-filter-th-box">
        <a-button @click="handlerReset">
          {{ $t('message["1625"]') }}
        </a-button>
        <a-button
          type="primary"
          html-type="submit"
          :loading="loadingVision"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('team/member', ['filterRShow', 'roleList']),
    ...mapState('team/manage', ['loadingVision']),
    filterDatas () {
      return this.roleList.map(item => {
        return {
          label: item.rolename,
          value: item.roleid
        }
      })
    }
  },
  async created () {
    this.fetchGetRoles({ status: 1 })
  },
  methods: {
    ...mapActions('team/member', ['fetchGetRoles']),
    ...mapActions('team/manage', ['fetchProjectMemberDatas']),
    ...mapMutations('team/member', ['setFilterRShow']),
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (document.querySelector('.main-content-table-list th[key="roleinfo"] .anticon-filter')) {
            document.querySelector('.main-content-table-list th[key="roleinfo"] .anticon-filter').click()
          }
          this.$emit('filterFromHandler', values)
          this.fetchProjectMemberDatas({ roleid: values.roleid.join(',') })
          this.setFilterRShow(false)
        }
      })
    },
    handlerReset () {
      this.form.resetFields()
      if (document.querySelector('.main-content-table-list th[key="roleinfo"] .anticon-filter')) {
        document.querySelector('.main-content-table-list th[key="roleinfo"] .anticon-filter').click()
      }
      this.$emit('filterFromHandler', {})
      this.fetchProjectMemberDatas()
      this.setFilterRShow(false)
    },
    resetForm () {
      this.form.resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
  .filter-form::v-deep {
    position: relative;
    padding-bottom: 56px;
    .ant-checkbox-group-item {
      width: 42%;
    }
    .pop-btn-box {
      position: fixed;
      bottom: 0;
    }
    .dev-form {
      padding:0 0 0 20px;
      .ant-form-item {
        margin-bottom: 0;
      }
    }
    .pop-btn-box {
      position: absolute;
      border-top: 1px solid #ebebeb;
      height: 36px;
      // padding-top: 12px;
      text-align: right;
      bottom: 0;
      right: 0;
      width: 100%;
      &.ant-form-item {
        margin-bottom: 0;
      }
      .ant-btn {
        background: none !important;
        border:none;
        color: #5077AA;
        box-shadow: none;
        text-shadow: none;
        line-height: 36px;
        height: 36px;
        border-radius: 0;
        padding: 0 26px;
        margin-right: 0;
      }
       .ant-btn-primary {
        border-left: 1px solid #ebebeb;

      }
    }
  }
</style>
